<a
    class="resource-featured-card selenium-resource-featured-card"
    [routerLink]="resource.getRouterLink()"
>
    <div class="header">
        <a
            [routerLink]="headerURL"
            (click)="stopPropagation($event)"
            *ngIf="resource.subject !== null"
            class="header-subject gtm-{{
                gtmPrefix
            }}-subject selenium-header-subject"
            [ngClass]="getSubjectClass()"
            [attr.data-gtmlabel]="resource.subject.displayName"
            [ngStyle]="{ backgroundColor: getSubjectColor() }"
            >{{ resource.subject.displayName }}
            <app-icon [type]="'Arrow-right'"></app-icon>
        </a>
        <app-resource-card-poster
            class="thumbnail"
            [title]="resource.title"
            [posterImage]="resource.getPosterImage(269, 151)"
            [duration]="resource.duration"
            [gtmPrefix]="gtmPrefix"
            [mediaType]="resource.mediaType[0]"
            [absoluteUrl]="resource.canonicalUrl"
        >
        </app-resource-card-poster>
    </div>
    <div class="content">
        <a
            [class]="getResourceBodyClass()"
            [attr.data-gtmlabel]="resource.canonicalUrl"
        >
            <app-card-title [height]="75">{{ resource.title }}</app-card-title>
        </a>

        <app-browse-card-meta
            [gradeRange]="resource.gradeRanges"
            [contentProject]="resource.project"
            [brand]="resource.brand"
            [supportMaterialsLink]="resource.getRouterLink(true)"
            [supportMaterialsCount]="resource.getSupportMaterialsCount()"
        ></app-browse-card-meta>
    </div>
</a>
